/* eslint-disable react/prop-types */
/* eslint-disable no-underscore-dangle */
import React, { useState, useEffect, useRef } from 'react'; // 👈 เพิ่ม useRef
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, Link } from 'react-router-dom';
// eslint-disable-next-line object-curly-newline
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  Card,
  TextField,
  InputAdornment,
  IconButton,
  Modal,
  Backdrop,
  Fade,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Checkbox,
  Grid, Menu,
  CircularProgress
} from '@mui/material';

import AddBoxIcon from '@mui/icons-material/AddBox';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import CancelIcon from '@mui/icons-material/Cancel';
import LogoutIcon from '@mui/icons-material/Logout';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SaveIcon from '@mui/icons-material/Save';

import { useForm, Controller, useFieldArray } from 'react-hook-form';
import dayjs from 'dayjs';
import _ from 'lodash';
import 'dayjs/locale/th';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import PropTypes from 'prop-types';
import * as actions from '../../redux/actions';
import Loading from '../../components/Loading';
import { Error, NotAuthorized } from '../../components/Error';
import accessSubModule from '../../utils/functions/accessSubModule';
import { ViewTitle } from '../../components/ViewTitle';
import { ProductEditExportAmountForm } from '../../components/Forms';
import ExelExport from '../../components/ExcelDownload/ExcelExport';
import { config, useQuery } from '../../configs';
dayjs.locale('th');
dayjs.extend(buddhistEra);

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90vw',
  boxShadow: 24,
  p: 4,
};

const ExportsManagement = ({ title, subtitle }) => {
  const module = 'SPM';
  const subModule = 'IMPORT';
  const dispatch = useDispatch();
  const productTransactionExport = useSelector(
    (state) => state.productTransactionExport,
  );
  // const productType = useSelector((state) => state.productType);
  const brand = useSelector((state) => state.brand);
  const me = useSelector((state) => state.me);

  const history = useHistory();
  const location = useLocation();
  // const product = useSelector((state) => state.product);


  // Setting React hook form
  const [searchTerm, setSearchTerm] = useState('');
  const [name, setName] = useState('');
  // const [page, setPage] = useState(1);
  // const [size, setSize] = useState(5);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [selectDate, setSelectDate] = useState('');
  const [total, setTotal] = useState(undefined);
  const [openExportOrder, setOpenExportOrder] = useState(false);
  const [nameExport, setNameExport] = useState('');
  const [exportId,] = useState(null);
  const [transactionType, setTypeDocText] = useState('ALL');
  const [statusDocText, setStatusDocText] = useState('ALL');
  const [sortExportBill, setSortExportBill] = useState('ASC');
  const [anchorEl, setAnchorEl] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [visibleOrders, setVisibleOrders] = useState(5); // แสดงคำสั่งซื้อ 5 รายการแรก
  const [openEditExportAmount, setOpenEditExportAmount] = useState(false);
  const [checkExportAll, setCheckExportAll] = useState(false);

  const [editExportAmount, setEditExportAmount] = useState(null);
  const [dataExportAmount, setDataExportAmount] = useState();
  const [uploadedImage, setUploadedImage] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const loadMore = () => setVisibleOrders(prev => prev + 100);
  const collapse = () => setVisibleOrders(5);

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
    setValue,
    watch,
  } = useForm({
    mode: 'onBlur',
  });

  const { fields, remove } = useFieldArray({
    control,
    name: 'optionList',
  });
  const handleOpenEditExportAmount = (data) => {
    setOpenEditExportAmount(true);
    if (!_.isEmpty(data?.orders)) {
      const optionArray = _.map(data?.orders, (eachOption) => ({
        ...eachOption,
        amount_export: 0,
      }));
      setValue('optionList', optionArray);
    }
    return () => { };
  };
  const handleCloseEditExportAmount = () => {
    setOpenEditExportAmount(false);
    setEditExportAmount(null);
    setUploadedImage(null);
    fields.forEach((e, index) => remove(index));
    setNameExport('');
    setCheckExportAll(false);
  };

  const loadMoreOrders = () => {
    setVisibleOrders((prev) => prev + 100); // โหลดเพิ่ม 5 รายการทุกครั้งที่กดปุ่ม
  };

  const loadMoreOrdersNa = () => {
    setVisibleOrders(5); // โหลดเพิ่ม 5 รายการทุกครั้งที่กดปุ่ม
  };


  // const transactionType = 'EXPORT';
  const getQueryParam = (paramName, defaultValue) => {
    const params = new URLSearchParams(location.search);
    const value = params.get(paramName);
    return value ? parseInt(value, 10) : defaultValue;
  };

  const [page, setPage] = useState(() => getQueryParam('page', 1));
  const [size, setSize] = useState(() => getQueryParam('size', 5));
  const isInitialMount = useRef(true);

  useEffect(() => {
    dispatch(actions.meGet());

    const fetchProductTransaction = async () => {
      try {
        // await dispatch(actions.productTransactionExportReset());
        await dispatch(
          actions.productTransactionExportAll({
            name,
            page,
            size,
            transactionType,
            statusDocText,
            sortExportBill,
            startDate,
            endDate,
            selectDate
          }),
        );
        // dispatch(actions.productTypeAll(''));
        dispatch(actions.brandAll(''));
      } catch (error) {
        console.error(error);
      }
    };
    fetchProductTransaction();
    return () => { };
  }, [name, page, size, transactionType, statusDocText, sortExportBill, startDate, endDate, selectDate, refreshKey]);

  useEffect(() => {
    setTotal(productTransactionExport?.total);
    return () => { };
  }, [productTransactionExport]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      // ตรวจสอบว่าใช่การโหลดครั้งแรกหรือไม่
      if (isInitialMount.current) {
        // ถ้าใช่ ให้เปลี่ยนค่าเป็น false แล้วไม่ต้องทำอะไรต่อ
        isInitialMount.current = false;
        // อาจจะ set name ไว้เฉยๆ ถ้าจำเป็น
        setName(searchTerm);
      } else {
        // ถ้าไม่ใช่การโหลดครั้งแรก (คือ user พิมพ์จริงๆ) ให้ทำงานตามปกติ
        setName(searchTerm);
        if (page !== 1) {
          setPage(1);
          // อัปเดต URL ด้วย
          const params = new URLSearchParams(location.search);
          params.set('page', '1');
          history.replace({ search: params.toString() });
        }
      }
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm, history]);
  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;
  const handleChangePage = (event, newPage) => {
    setPage(newPage + 1);
    // สร้าง params จาก URL ปัจจุบัน
    const params = new URLSearchParams(location.search);
    // ตั้งค่า page ใหม่ (ค่า size เดิมจะยังคงอยู่)
    params.set('page', newPage + 1);
    // อัปเดต URL
    history.replace({ search: params.toString() });
  };
  const handleDelete = async (id) => {
    const confirm = window.confirm('ยืนยันการลบข้อมูลส่งออก');
    if (confirm) {
      try {
        await dispatch(actions.productTransactionExportDelete(id));
        await dispatch(
          actions.productTransactionExportAll({
            name,
            page,
            size,
            transactionType,
            statusDocText,
            startDate,
            endDate,
            selectDate
          }),
        );
      } catch (error) {
        console.error(error);
      }
    }
  };


  // const handleUpdateStatusAll = async (id) => {
  //   const confirm = window.confirm('ยืนยันการจ่ายสินค้า');
  //   if (confirm) {
  //     try {
  //       await dispatch(
  //         actions.productTransactionExportPut(id, {
  //           status_export: 'SUCCESS',
  //           export_employee_real: me?.userData?._id,
  //           export_employee_real_string: nameExport,
  //           real_export_date: dayjs(new Date())
  //             .locale('th')
  //             .format('YYYY-MM-DD'),
  //         }),
  //       );
  //       await dispatch(
  //         actions.productTransactionExportAll({
  //           name,
  //           page,
  //           size,
  //           transactionType,
  //           statusDocText,
  //         }),
  //       );
  //       setNameExport('');
  //       setOpenExportOrder(false);
  //       setOpenEditExportAmount(false);
  //       setEditExportAmount(null);
  //       fields.forEach((e, index) => remove(index));
  //     } catch (error) {
  //       console.error(error);
  //     }
  //   }
  // };


  const handleUpdateStatus = async (id) => {
    const confirm = window.confirm(
      'กรุณาตรวจสอบการจ่ายสินค้า ก่อนกดจ่ายสำเร็จ',
    );

    if (confirm) {
      try {
        await dispatch(
          actions.productTransactionExportPut(id, {
            status_export: 'SUCCESS',
            type_edit: 'UPDATE_EXPORT_STATUS',
          }),
        );
        await dispatch(
          actions.productTransactionExportAll({
            name,
            page,
            size,
            transactionType,
            statusDocText,
            startDate,
            endDate,
            selectDate
          }),
        );
        setNameExport('');
        setOpenExportOrder(false);
      } catch (error) {
        console.error(error);
      }
    }
  };

  const onSubmitEditExportAmount = async (data) => {
    if (isSubmitting) return;

    setIsSubmitting(true);
    const realExportDate = dayjs(new Date()).locale('th').format('YYYY-MM-DD');

    try {
      // 1. เตรียมข้อมูลพื้นฐาน
      const fieldData = (data?.optionList || []).map((each) => ({
        ...each,
        amount_export: parseFloat(each.amount_export || 0),
        amount_export_real: parseFloat(each.amount_export_real || 0),
      }));

      // 2. ตรวจสอบเงื่อนไข (Validation)
      // ถ้าไม่ได้เลือก "จ่ายทั้งหมด" ต้องเช็คว่าจ่ายเกินจำนวนที่มีหรือไม่
      if (!checkExportAll) {
        const findError = _.find(fieldData, (each) =>
          (each.amount_export + each.amount_export_real) > each.amount || (each.amount_export < 0)
        );


        if (findError) {
          alert('❌ กรุณาตรวจสอบจำนวนการจ่าย: จำนวนที่ระบุรวมกับที่เคยจ่ายไปแล้ว ห้ามเกินจำนวนทั้งหมด หรือกรอกจ่ายจำนวนติดลบ');
          setIsSubmitting(false);
          return;
        }
      }

      // 3. ยืนยันก่อนดำเนินการ
      if (!window.confirm('ยืนยันการบันทึกข้อมูลการจ่ายสินค้า?')) {
        setIsSubmitting(false);
        return;
      }

      // 4. สร้าง Payload ตามเงื่อนไข checkExportAll
      // แยกตรรกะระหว่าง "จ่ายทั้งหมด (SUCCESS)" และ "บันทึกจำนวน (WAIT_FOR_EXPORT)"
      const payload = {
        export_employee_real: me?.userData?._id,
        export_employee_real_string: nameExport,
        real_export_date: realExportDate,
        images: _.map(uploadedImage || [], (image) => ({
          id: image._id,
          image: image.data_url || image.url,
        })),
      };

      if (checkExportAll) {
        // กรณี "จ่ายทั้งหมด"
        await dispatch(
          actions.productTransactionExportPut(editExportAmount?._id, {
            status_export: 'SUCCESS',
            export_employee_real: me?.userData?._id,
            export_employee_real_string: nameExport,
            real_export_date: dayjs(new Date())
              .locale('th')
              .format('YYYY-MM-DD'),
          }),
        );
        await dispatch(
          actions.productTransactionExportAll({
            name,
            page,
            size,
            transactionType,
            statusDocText,
            startDate,
            endDate,
            selectDate
          }),
        );
        setNameExport('');
        setOpenExportOrder(false);
        setOpenEditExportAmount(false);
        setEditExportAmount(null);
        setUploadedImage(null);
        setCheckExportAll(false);
      } else {
        // กรณี "ระบุจำนวน"
        payload.status_export = 'WAIT_FOR_EXPORT';
        payload.type_edit = 'UPDATE_EXPORT_AMOUNT';
        payload.orders = fieldData.map((each) => ({
          product: each.product?._id,
          amount: each.amount,
          amount_export: each.amount_export + each.amount_export_real,
          amount_export_real: each.amount_export_real,
          warehouse: each.warehouse?._id,
          price: 0,
          cost_price: 0,
        }));
      }

      // 5. ยิง API
      await dispatch(actions.productTransactionExportPut(editExportAmount?._id, payload));

      // 6. เคลียร์ UI และปิด Modal ทันที (เพื่อให้ Alert ไม่ทับหน้าจอ Loading)
      setIsSubmitting(false);
      setOpenEditExportAmount(false);

      // 7. แจ้งเตือน และ Refresh ข้อมูล
      setTimeout(async () => {
        alert('🎉 บันทึกข้อมูลการจ่ายสินค้าเรียบร้อยแล้ว');

        // ดึงข้อมูลใหม่มาแสดงในตารางหน้าหลัก
        await dispatch(actions.productTransactionExportAll({
          name, page, size, transactionType, statusDocText, startDate, endDate, selectDate,
        }));

        // ล้าง State ของฟอร์ม
        setNameExport('');
        setEditExportAmount(null);
        setUploadedImage(null);
        setCheckExportAll(false);
        reset({ optionList: [] }); // รีเซ็ตข้อมูลในฟอร์มของ React Hook Form
      }, 100);

    } catch (error) {
      console.error('[SUBMIT ERROR]', error);
      alert(`⚠️ เกิดความผิดพลาด: ${error?.message || 'โปรดติดต่อผู้ดูแลระบบ'}`);
      setIsSubmitting(false);
    }
  };



  const handleChangeCheckExportAll = (event) => {
    setCheckExportAll(event.target.checked);
  };

  const handleOpenExportOrder = () => {
    setOpenExportOrder(true);
  };
  const handleCloseExportOrder = () => {
    setOpenExportOrder(false);
  };

  const handleChangeRowsPerPage = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setSize(newSize);
    setPage(1); // เมื่อเปลี่ยน size ให้กลับไปหน้า 1 เสมอ

    // --- ✨ เพิ่มโค้ดส่วนนี้เพื่ออัปเดต URL ---
    const params = new URLSearchParams(location.search);
    params.set('page', '1');
    params.set('size', newSize);
    history.replace({ search: params.toString() });
    // --- จบส่วนที่เพิ่ม ---
  };
  const handleToInfoPage = async (id) => {
    history.push(`/spm/exports/${id}?page=${page}&size=${size}`);
  };

  const handleToEditPage = async (id) => {
    history.push(`/spm/export/edit/${id}?page=${page}&size=${size}`);
  };
  const fullQueryParams = new URLSearchParams({
    page: 1,
    size: 5000,
  })

  const handleChangeTypeDoc = (value) => {
    if (value === 'EXPORT') {
      setTypeDocText('EXPORT');
    } else if (value === 'RESERVE') {
      setTypeDocText('RESERVE');
    } else {
      setTypeDocText('ALL');
    }
  };
  const handleDropdownClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleDropdownClose = () => {
    setAnchorEl(null);
  };
  const handleChangeStatusDoc = (value) => {
    if (value === 'SUCCESS') {
      setStatusDocText('SUCCESS');
    } else if (value === 'WAIT_FOR_EXPORT') {
      setStatusDocText('WAIT_FOR_EXPORT');
    } else {
      setStatusDocText('ALL');
    }
  };
  ;

  const renderAddButton = () => (
    <div className="flex flex-row justify-end ">

      <div className="flex flex-row justify-end pb-8">
        <Button
          startIcon={<AddBoxIcon />}
          variant="contained"
          onClick={handleDropdownClick}
        >
          สร้างใบส่งออก
        </Button>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleDropdownClose}
        >
          <MenuItem
            onClick={() => {
              handleDropdownClose();
              history.push('/spm/exports/create');
            }}
          >
            สร้างใบส่งออก
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleDropdownClose();
              history.push('/spm/exports/create_many');
            }}
          >
            สร้างใบส่งออกหลายสินค้า
          </MenuItem>
        </Menu>

      </div>

    </div>
  );

  const renderModalExportOrders = () => (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={openExportOrder}
      onClose={handleCloseExportOrder}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={openExportOrder}>
        <Card sx={style} className="max-w-2xl my-4">
          <div className="max-h-screen overflow-y-auto">
            <div className="">
              <div className="text-xl pb-4 underline">ชื่อผู้รับสินค้าจริง</div>
              <div>
                <TextField
                  fullWidth
                  label="ชื่อผู้รับสินค้าจริง"
                  value={nameExport}
                  onChange={(event) => {
                    setNameExport(event.target.value);
                  }}
                />
              </div>
            </div>
            <div className="flex flex-row justify-end gap-1 py-4">
              <Button
                variant="contained"
                startIcon={<SaveIcon />}
                onClick={() => handleUpdateStatus(exportId)}
              >

                บันทึก
              </Button>

              <Button variant="outlined" onClick={handleCloseExportOrder}>
                ปิด
              </Button>
            </div>
          </div>
        </Card>
      </Fade>
    </Modal>
  );


  const renderModalEditExportAmount = () => (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={openEditExportAmount}
      onClose={isSubmitting ? undefined : handleCloseEditExportAmount}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={openEditExportAmount}>
        <Card sx={style} className="max-w-6xl my-8">
          {isSubmitting && (
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1000,
                borderRadius: '8px',
              }}
            >
              <div style={{ textAlign: 'center' }}>
                <CircularProgress size={60} />
                <div style={{ marginTop: '16px', fontSize: '16px', fontWeight: 'bold' }}>
                  กำลังบันทึกข้อมูล...
                </div>
              </div>
            </div>
          )}
          <div className="max-h-screen overflow-y-auto" style={{
            position: 'relative',
            opacity: isSubmitting ? 0.6 : 1 // ลด opacity ขณะ loading
          }}>
            <div className="p-2 bg-gray-600 text-white m-1 w-full">
              จำนวนการจ่าย
            </div>
            <div className="py-2">
              <form onSubmit={handleSubmit(onSubmitEditExportAmount)}>
                <ProductEditExportAmountForm
                  errors={errors}
                  product={editExportAmount}
                  control={control}
                  Controller={Controller}
                  setValue={setValue}
                  fields={fields}
                  watch={watch}
                  checkExportAll={checkExportAll}
                />
                <div className="">
                  <div className="text-lg pb-4 underline">
                    ชื่อผู้รับสินค้าจริง
                  </div>
                  <div>
                    <TextField
                      fullWidth
                      label="ชื่อผู้รับสินค้าจริง"
                      value={nameExport}
                      size="small"
                      defaultValue={
                        editExportAmount?.export_employee_real_string
                      }
                      onChange={(event) => {
                        setNameExport(event.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="flex flex-row justify-end gap-1 py-4">
                  {/* <Button
                    variant="contained"
                    startIcon={<SaveIcon />}
                    onClick={() => handleUpdateStatusAll(editExportAmount?.id)}
                  >
                    บันทึก ( กรณีจ่ายทั้งหมด )
                  </Button> */}
                  {!_.find(
                    editExportAmount?.orders,
                    (e) => e?.amount_export_real > 0,
                  ) && (
                      <>
                        <Checkbox
                          checked={checkExportAll}
                          onChange={handleChangeCheckExportAll}
                        />
                        <div className="my-auto mr-4">จ่ายทั้งหมด</div>
                      </>
                    )}

                  <Button
                    variant="contained"
                    startIcon={<SaveIcon />}
                    type="submit"
                  // onClick={() => handleUpdateStatus(exportId)}
                  >
                    บันทึก
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={handleCloseEditExportAmount}
                  >
                    ปิด
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </Card>
      </Fade>
    </Modal>
  );

  const renderSearch = () => (
    <Card>
      <div className="p-4 flex gap-2">
        <div className="w-full md:w-1/2">
          <TextField
            label="ค้นหา"
            fullWidth
            size={'small'}
            id="outlined-start-adornment"
            onChange={(e) => {
              setSearchTerm(e.target.value);
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <i className="fas fa-search"></i>
                </InputAdornment>
              ),
            }}
          />
        </div>
        <Grid item xs={12} md={2.5}>
          <TextField
            label="วันที่เริ่มต้นของสัปดาห์"
            type="date"
            fullWidth
            size="small"
            value={startDate}
            onChange={(e) => {
              setStartDate(e.target.value);
              setPage(1);
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        <Grid item xs={12} md={2.5}>
          <TextField
            label="วันที่สิ้นสุดของสัปดาห์"
            type="date"
            fullWidth
            size="small"
            value={endDate}
            onChange={(e) => {
              setEndDate(e.target.value);
              setPage(1);
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        <div className="w-full flex gap-2 md:w-1/2">
          <div className="w-1/2">
            <FormControl className="w-full">
              <InputLabel id="type" size={'small'}>
                เลือกรายการแสดง
              </InputLabel>
              <Select
                label="เลือกรายการแสดง"
                size={'small'}
                fullWidth
                defaultValue="ALL"
                onChange={(e) => {
                  handleChangeTypeDoc(e.target.value);
                }}
              >
                <MenuItem value="ALL">แสดงทั้งหมด</MenuItem>
                <MenuItem value="EXPORT">การส่งออก</MenuItem>
                <MenuItem value="RESERVE">การจองสินค้า</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div className="w-1/2">
            <FormControl className="w-full">
              <InputLabel id="type" size={'small'}>
                เลือกสถานะส่งออก
              </InputLabel>
              <Select
                label="เลือกสถานะส่งออก"
                size={'small'}
                fullWidth
                defaultValue="ALL"
                onChange={(e) => {
                  handleChangeStatusDoc(e.target.value);
                }}
              >
                <MenuItem value="ALL">แสดงทั้งหมด</MenuItem>
                <MenuItem value="SUCCESS">รับสินค้าแล้ว</MenuItem>
                <MenuItem value="WAIT_FOR_EXPORT">รอจ่ายสินค้า</MenuItem>
              </Select>
            </FormControl>
          </div>
        </div>
        {/* <div>
          <Button onClick={() => setSortExportBill('DESC')}>SORT</Button>
        </div> */}
      </div>
    </Card>
  );

  const OrderComponentList = ({ orders }) => {
    const [visibleOrders, setVisibleOrders] = useState(5);

    const loadMore = () => setVisibleOrders((prev) => prev + 100);
    const collapse = () => setVisibleOrders(5);

    return (
      <div>
        {orders?.slice(0, visibleOrders).map((eachOrder, index) => (
          <div key={index} className="w-full py-1">
            <div className="flex justify-between">
              {/* ลำดับ + ชื่อสินค้า */}
              <p>
                {index + 1} : {eachOrder?.product?.model_name}
              </p>

              {/* คลังสินค้า */}
              <div>{eachOrder?.warehouse?.name}</div>

              {/* จำนวน + หน่วย */}
              <div className="flex gap-1">
                <p>{eachOrder?.amount}</p>
                <p>{eachOrder?.product?.unit}</p>
              </div>
            </div>
          </div>
        ))}

        {/* ปุ่ม load more / ย่อ */}
        {orders?.length > 5 && (
          visibleOrders >= orders.length ? (
            <div className="flex justify-center mt-2">
              <Button variant="contained" color="primary" onClick={collapse}>
                ย่อ
              </Button>
            </div>
          ) : (
            <div className="flex justify-center mt-2">
              <Button variant="contained" color="primary" onClick={loadMore}>
                แสดงเพิ่ม
              </Button>
            </div>
          )
        )}
      </div>
    );
  };
  const renderTable = () => (
    <div className="my-2">
      <Paper>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }}>
            <colgroup>
              <col width="5%" />
              <col width="10%" />
              <col width="10%" />
              <col width="35%" />
              <col width="10%" />
              <col width="10%" />
              <col width="10%" />
              <col width="10%" />
              <col width="10%" />
            </colgroup>
            <TableHead>
              <TableRow>
                <TableCell>
                  <div className="font-bold">ลำดับที่</div>
                </TableCell>
                {/* <TableCell>
                  <div className="font-bold">หมายเลขเอกสาร</div>
                </TableCell> */}
                <TableCell>
                  <div className="font-bold">หมายเลขโครงการ/บิล</div>
                </TableCell>
                <TableCell>
                  <div className="font-bold">คู่ค้า/ผู้จอง</div>
                </TableCell>
                {/* <TableCell>
                  <div className="font-bold">ชื่อสินค้า</div>
                </TableCell> */}
                <TableCell>
                  <div className="font-bold">
                    รุ่นสินค้า / คลัง / จำนวนสินค้า
                  </div>
                </TableCell>
                {/* <TableCell>
                  <div className="font-bold">คลัง</div>
                </TableCell>
                <TableCell>
                  <div className="font-bold">จำนวนสินค้า</div>
                </TableCell> */}
                <TableCell>
                  <div className="font-bold">สถานะ</div>
                </TableCell>
                <TableCell>
                  <div className="font-bold">วันที่จัดสินค้า</div>
                </TableCell>
                <TableCell>
                  <div className="font-bold">วันที่ส่งออก</div>
                </TableCell>
                <TableCell>
                  <div className="font-bold">ผู้ส่งออก</div>
                </TableCell>
                <TableCell>
                  <div className="font-bold">ดำเนินการ</div>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {!_.isEmpty(productTransactionExport.rows) ? (
                productTransactionExport.rows.map((row, index) => (
                  <TableRow
                    key={index}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    className={index % 2 === 0 ? 'bg-gray-100' : ''}
                  >
                    <TableCell component="th" scope="row">
                      <IconButton
                        color="primary"
                        onClick={() => handleToEditPage(row?._id)}
                        disabled={
                          row?.status_export === 'SUCCESS' ||
                          row?.status_edit ||
                          (row?.updatedAt &&
                            row?.createdAt &&
                            dayjs(row.updatedAt).diff(
                              dayjs(row.createdAt),
                              'second',
                            ) > 5)
                        }
                      >
                        <EditOutlinedIcon />
                      </IconButton>

                      {(page - 1) * size + index + 1}
                    </TableCell>

                    {/* <TableCell
                      component="th"
                      scope="row"
                      className="text-center"
                    >
                      {row?.reserve_order && (
                        <div className="rounded-md bg-blue-400 p-1 text-center mb-1">
                          จองสินค้า
                        </div>
                      )}
                      <a
                        className="hover:underline cursor-pointer w-full text-center"
                        onClick={() => handleToInfoPage(row?.id)}
                      >
                        {row?.running_number || '-'}
                      </a>
                    </TableCell> */}
                    <TableCell component="th" scope="row">
                      {row?.reserve_order && (
                        <div className="rounded-md bg-blue-400 p-1 text-center mb-1">
                          จองสินค้า
                        </div>
                      )}
                      <div>{row?.project_number || '-'}</div>
                      <div>{row?.bill_number || '-'}</div>
                    </TableCell>
                    <TableCell onClick={() => handleToInfoPage(row?._id)}>
                      <a className="hover:underline cursor-pointer">
                        {row?.customer?.name || '-'}
                      </a>
                      <div
                        className="hover:underline cursor-pointer"
                        onClick={() => handleToInfoPage(row?.id)}
                      >
                        {row?.reserve_employee || '-'}
                      </div>
                    </TableCell>
                    {/* <TableCell>
                      {row?.orders?.map((eachOrder, _index) => (
                        <div key={_index} className="w-full py-1">
                          <div className="flex">
                            <p className="">
                              {_index + 1} : {eachOrder?.product?.name}
                            </p>
                          </div>
                        </div>
                      ))}
                    </TableCell> */}
                    <TableCell>
                      <OrderComponentList orders={row?.orders} />
                    </TableCell>
                    {/* <TableCell>
                      {row?.orders?.map((eachOrder, _index) => (
                        <div key={_index} className="w-full py-1">
                          <div className="">{eachOrder?.warehouse?.name}</div>
                        </div>
                      ))}
                    </TableCell>
                    <TableCell>
                      {row?.orders?.map((eachOrder, _index) => (
                        <div key={_index} className="w-full py-1">
                          <div className="flex gap-1">
                            <p className="">{eachOrder?.amount}</p>
                            <p className=" ">{eachOrder?.product?.unit}</p>
                          </div>
                        </div>
                      ))}
                    </TableCell> */}
                    <TableCell>
                      {row?.status_export === 'WAIT_FOR_EXPORT' ? (
                        <div className="rounded-md bg-yellow-400 p-1 text-center">
                          รอจ่ายสินค้า
                        </div>
                      ) : (
                        <div className="rounded-md bg-green-300 p-1 text-center">
                          รับสินค้าแล้ว
                        </div>
                      )}
                      {row?.status_return === 'ALL_IN' && (
                        <div className="rounded-md bg-green-400 p-1 text-center mt-1">
                          คืนสินค้าแล้ว
                        </div>
                      )}
                    </TableCell>
                    <TableCell>
                      {`${dayjs(row?.createdAt).format('D MMM BBBB ')}`}
                    </TableCell>
                    <TableCell>
                      {`${
                        // eslint-disable-next-line no-nested-ternary
                        row?.status_export === 'SUCCESS'
                          ? row?.real_export_date
                            ? dayjs(row?.real_export_date).format('D MMM BBBB ')
                            : row?.export_date
                              ? dayjs(row?.export_date).format('D MMM BBBB ')
                              : '-'
                          : '-'
                        }`}
                    </TableCell>
                    <TableCell>
                      <div>{row?.export_employee_real?.firstname || '-'}</div>
                    </TableCell>
                    <TableCell>
                      <div className="mb-1">
                        <Button
                          variant="contained"
                          fullWidth
                          startIcon={<LogoutIcon />}

                          onClick={() => {
                            setEditExportAmount(row);
                            setUploadedImage(row?.images || []);
                            handleOpenEditExportAmount(row);
                            setNameExport(row?.export_employee_real_string);
                          }}
                          disabled={row?.status_export === 'SUCCESS'}
                        >
                          จ่ายสินค้า
                        </Button>
                      </div>
                      <div className="mb-1">
                        <Button
                          variant="contained"
                          fullWidth
                          color="success"
                          startIcon={<CheckCircleIcon />}
                          onClick={() => {
                            handleUpdateStatus(row?._id);
                          }}
                          disabled={row?.status_export === 'SUCCESS'}
                        >
                          จ่ายสำเร็จ
                        </Button>
                      </div>
                      <div>
                        <Button
                          variant="contained"
                          fullWidth
                          color="error"
                          startIcon={<CancelIcon />}
                          onClick={() => {
                            handleDelete(row?._id);
                          }}
                          disabled={row?.status_export === 'SUCCESS'}
                        >
                          ยกเลิก
                        </Button>
                      </div>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6}>
                    <div className="text-center">ไม่มีข้อมูล</div>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          rowsPerPageOptions={[5, 10, 25, 100]}
          onRowsPerPageChange={handleChangeRowsPerPage}
          page={page - 1}
          count={total || 1}
          rowsPerPage={size}
          onPageChange={handleChangePage}
        />
      </Paper>
    </div>
  );

  if (productTransactionExport.isLoading || !productTransactionExport.rows) {
    return <Loading />;
  }
  if (
    !productTransactionExport.isLoading &&
    productTransactionExport.isCompleted
  ) {
    if (accessSubModule(me?.userData?.access, module, subModule)) {
      return (
        <div className="">
          {renderModalExportOrders()}
          {renderModalEditExportAmount()}
          <div className="flex justify-between">
            <div>{renderTitle()}</div>
            {
              me?.userData?.access_button?.export && (
                <div className="mt-6 flex gap-2  pt-8">
                  <div className="w-full md:w-auto pr-2 text-right">
                    <ExelExport
                      productTransactions={productTransactionExport?.rows}
                      exports={true}
                      name={name}
                      statusDocText={statusDocText}
                      dataAPIEndPoint="product-transaction-export"
                      startDate={startDate}
                      endDate={endDate}
                      selectDate={selectDate}
                      transactionType={transactionType}
                      // productTypes={productType?.rows}
                      brands={brand?.rows}
                    />
                  </div>
                  {renderAddButton()}
                </div>
              )
            }
          </div>
          {renderSearch()}
          {renderTable()}
        </div>
      );
    }
    return <NotAuthorized />;
  }
  return <Error message={productTransactionExport?.message} />;
};

ExportsManagement.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

ExportsManagement.defaultProps = {
  title: '',
  subtitle: '',
};

export default ExportsManagement;
